// Admin API client — /admin/content-keys/* (mirrors the API's content-keys aggregate).

import type {
  ContentKeyListResponse,
  ContentKeyMintRequest,
  ContentKeyMintResponse,
  ContentKeySummary,
} from '@a7y/types';
import { client } from './transport';

export const contentKeysApi = {
  // ------------------------------------------------------------------------------------
  // Content keys (A7Y-4478) — the credential the content CLI sends. The mint
  // response is the only place the key itself ever appears.
  contentKeys: {
    list: () => client.get<ContentKeyListResponse>('/content-keys'),
    mint: (data: ContentKeyMintRequest) =>
      client.post<ContentKeyMintResponse>('/content-keys', data),
    revoke: (id: string) =>
      client.post<{ success: true; data: ContentKeySummary }>(`/content-keys/${id}/revoke`),
  },
};
